import {
  PricePlanExchange,
  PricePlanExchangeForm,
} from '@/mobile/types/api/mypage/pricePlanExchange';
import { atom } from 'recoil';

/**
 * 料金プラン変更関連のグローバルステート
 * 料金プラン変更の選択肢や入力値を管理する。
 * プラン選択から変更確認までの画面遷移で状態を保持する。
 */
export const pricePlanExchangeDefault: PricePlanExchange = {
  // 画面表示可否
  can_display: false,
  // 料金プラン変更可否
  can_price_plan_exchange: false,
  // 「変更しない」実施可否
  can_price_plan_no_change: false,
  // 音声通話定額サービス変更可否
  can_call_flat_rate_plan_exchange: false,
  // 契約書面電子交付方法
  has_contract_delivery: '',
  // データ前借有無
  is_using_advance: false,
  // 利用中の料金プラン契約情報
  usage_price_plan_info: {
    // 利用中の料金プラン種別
    price_plan_type: '',
    // 利用中の料金プラン契約情報
    price_plan_code: '',
    // 料金プラン名称
    price_plan_name: '',
  },
  // 利用中のオプション契約情報
  usage_option_info: {
    // バリューデータフリー
    has_value_data_free: false,
    // 限定プレミアムオプション
    has_premium_band: false,
  },

  // 利用中の音声通話定額サービス契約情報
  usage_call_flat_rate_info: {
    // 料金プランコード
    code: '',
    // 料金プラン名称
    name: '',
    // オプションクラス区分
    class_type: '',
  },
  select_price_plan_group_info: [],
  select_call_flat_rate_info: [],
};

export const pricePlanExchangeState = atom<PricePlanExchange>({
  key: 'pricePlanExchangeState',
  default: pricePlanExchangeDefault,
});

export const pricePlanExchangeFormDefault = {
  // 初期表示時、未選択を示すnoneをセット
  premium_band_operation: 'none',
  call_flat_rate_plan_operation: 'none',
  price_plan_group_type: 'none',
  price_plan_code: '',
};

export const pricePlanExchangeFormState = atom<PricePlanExchangeForm>({
  key: 'pricePlanExchangeFormState',
  default: pricePlanExchangeFormDefault,
});

export default pricePlanExchangeState;
